import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistedStore, store } from "./globalState/store.ts";
import { CartProvider } from "./contexts/CartContext";
import "./i18n";
import AppThemeProvider from "./theme/AppThemeProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <PersistGate loading={null} persistor={persistedStore}>
        <Suspense fallback={<div>Loading...</div>}>
          <AppThemeProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </AppThemeProvider>
        </Suspense>
      </PersistGate>
    </React.StrictMode>
  </Provider>
);

reportWebVitals();
